import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { withDashboardContext, withRouter } from '@stackhouse/dashboard-components/Dashboard'

import { Flex } from '@stackhouse/styled-elements'

import FilterPage from './filter'
import GridPage from './grid'

import isMobile from '../utils/is-mobile'

class FilterGridPage extends PureComponent {

    static propTypes = {
        functionName: PropTypes.string.isRequired,
        gridFunctionName: PropTypes.string.isRequired,
        filterEndpoint: PropTypes.string.isRequired,
        childPath: PropTypes.string,
        showDataList: PropTypes.bool,
    }

    static forwardedMethods = [
        'loadData'
    ]

    constructor(props) {
        super(props)
        this.state = { results: { elementCount: 0, elements: [] }, showSort: false }
        this.gridRef = React.createRef()
        this.filterRef = React.createRef()
        this.setShowSort = showSort => this.setState({ showSort })
        this.setResults = (elements, elementCount) => this.setState({ results: { elements, elementCount } })
    }

    getFilter = () => {
        return this.filterRef.current.getFilter()
    }

    loadData = () => {
        //return this.filterRef.current.search()
        return this.filterRef.current != null ? this.filterRef.current.search() : null
    }

    render() {
        const { match: { url } } = this.props
        const { results, showSort } = this.state
        const { functionName, gridFunctionName, filterEndpoint, childPath, showDataList = isMobile } = this.props
        return (
            <Flex column fill>
                <FilterPage
                    ref={this.filterRef}
                    onResult={this.setResults}
                    filterEndpoint={filterEndpoint}
                    functionName={functionName}
                    showSort={showSort}
                    onChangeShowSort={this.setShowSort}
                />
                <GridPage
                    rows={results}
                    ref={this.gridRef}
                    showSort={showSort}
                    showDataList={showDataList}
                    functionName={gridFunctionName}
                    loadData={this.loadData}
                    childPath={childPath || `${url}/{{idnrr}}`}
                />
            </Flex>
        )
    }
}

export default withDashboardContext(withRouter(FilterGridPage), ({ client, withLoader }) => ({ client, withLoader }))
